var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"register-button btn cta full"},[_c('fa',{staticClass:"register-button__icon",attrs:{"icon":['fas', 'coins']}}),_vm._v("\n  120 Gratis credits\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }